import React, { useState } from 'react';
import './Carousel.css';
import { LeftOutlined, RightOutlined , CloseOutlined} from '@ant-design/icons';

const Carousel = ({ images, startIndex, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(startIndex);

  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    const isLastSlide = currentIndex === images.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  return (
    <div className="carousel">
          <div  onClick={onClose} className='close'><CloseOutlined/></div>
      <div className="carousel__overlay" onClick={onClose}></div>
    <div className='carousel__container'>
      <div className="carousel__content">
        <div className="carousel__button--left" onClick={goToPrevious}>
        <LeftOutlined />
        </div>
        <div
          className="carousel__image"
          style={{ backgroundImage: `url(${images[currentIndex].img})` }}
        ></div>
        <div className="carousel__button--right" onClick={goToNext}>
        <RightOutlined />
        </div>
        <div className='carousel_button_container'>
        <div className="carousel_button" onClick={goToPrevious}>
        <LeftOutlined />
        </div>
        <p className='carousel_description'>{images[currentIndex].description}</p>

        <div className="carousel_button" onClick={goToNext}>
        <RightOutlined />
        </div>
        </div>
      </div>
            <p className='carousel_description2'>{images[currentIndex].description}</p>

      </div>
    </div>
  );
};

export default Carousel;